export default class Attribute {
  constructor(attribute = {}) {
    this.id = attribute.id || null
    this.value = attribute.value
    this.type = attribute.type || { audits: [], scraper: {}, secondary_scrapers: [] }
    this.created_at = attribute.created_at || null
    this.updated_at = attribute.updated_at || null
    this.changes = attribute.changes || []
    this.findings = attribute.findings || []
    this.unresolved_findings = attribute.unresolved_findings || []
  }

  mutations() {
    return {
      setAttribute: (state, attribute) => state.attribute = new Attribute(attribute),
      clearAttribute: (state) => state.attribute = new Attribute(),
    }
  }
}